module.exports = __webpack_public_path__ + "img/ic_fluent_arrow_maximize_28_filled.22d10e7c.svg";